import { useEffect, useState } from 'react'
import { Box, FormHelperText, Link, TextField, Typography } from '@material-ui/core'

import { useNotification } from 'hooks'
import { isValidUrl } from 'modules'

const errorMessage = 'The link format is invalid'

type Props = {
    isEditMode: boolean
    stepGoTo: {
        href: string
        host: string
    }
    link: string
    onUpdate: (_value: string) => void
}

export const StepGoTo = ({ isEditMode, stepGoTo, link, onUpdate }: Props) => {
    const { showErrorNotification } = useNotification()

    const [linkField, setLinkField] = useState(link)

    useEffect(() => {
        setLinkField(link)
    }, [link])

    const showErrorMessage = linkField.length > 0 && !isValidUrl(linkField)

    // Do not render anything if stepGoTo link is not valid and view mode
    if (!stepGoTo.host && !isEditMode) return null

    if (isEditMode) {
        return (
            <Box mb={2}>
                <TextField
                    label="Go to link"
                    value={linkField}
                    variant="filled"
                    fullWidth
                    onBlur={() => {
                        if (showErrorMessage) {
                            showErrorNotification(errorMessage)
                            setLinkField(link)
                            return
                        }
                        // we need to make update only if field was changed
                        if (link !== linkField) onUpdate(linkField)
                    }}
                    onClick={e => e.stopPropagation()}
                    onChange={event => setLinkField(event.target.value)}
                />
                {showErrorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
            </Box>
        )
    }

    return (
        <Box mb={2}>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                Go to{' '}
                <Link
                    underline="none"
                    href={stepGoTo.href}
                    target="_blank"
                    variant="body1"
                    style={{
                        color: '#2D9CDB',
                        fontWeight: 'bold'
                    }}
                >
                    {stepGoTo.host}
                </Link>
            </Typography>
        </Box>
    )
}
